export type ReleaseNote = {
    id: number
    title: string
    description: string
}

export const releaseNotes: ReleaseNote[] = [
    {
        id: 1,
        title: 'Manglende prøver og dokumentasjon',
        description: 'Få oversikt over manglende prøver og dokumentasjon 🎉',
    },
]

export const latestReleaseNote = releaseNotes.at(-1) ?? null
